import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { EmergencyButton } from './EmergencyControls';
import { useApprovals } from './ApprovalProvider';
import { usePedidosBadge } from './PedidosBadgeProvider';
import WhatsAppBadge from './WhatsAppBadge';
import './Header.css';

const Header = () => {
    const { isLoggedIn, user, logout } = useAuth();
    const location = useLocation();
    const { summary } = useApprovals();
    const pedidos = usePedidosBadge();

    // Admins: requests waiting for them. Sales: their requests that were denied lately (needs attention), else those still waiting.
    const bellDenied = user?.role !== 'admin' && summary.denied > 0;
    const bellCount = bellDenied ? summary.denied : summary.pending;

    if (location.pathname.endsWith('/print')) {
        return null;
    }

    return (
        <header className="header">
            <div className="logo-container">
                <img src="/CGCLogo.png" alt="Caribbean Gas Company Logo" className="logo" />
            </div>

            {isLoggedIn && (
                <nav className="header-nav">
                    <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>Dashboard</NavLink>
                    <NavLink to="/clients" className={({ isActive }) => isActive ? 'active' : ''}>Clientes</NavLink>
                    <NavLink to="/products" className={({ isActive }) => isActive ? 'active' : ''}>Productos</NavLink>
                    {user.role === 'admin' && (
                        <NavLink to="/expenses" className={({ isActive }) => isActive ? 'active' : ''}>Gastos</NavLink>
                    )}
                    <NavLink to="/quotes" className={({ isActive }) => isActive ? 'active' : ''}>Cotizaciones</NavLink>
                    <NavLink to="/conduces" className={({ isActive }) => isActive ? 'active' : ''}>Conduces</NavLink>
                    <NavLink to="/invoices" className={({ isActive }) => isActive ? 'active' : ''}>Facturas</NavLink>
                    <NavLink to="/ingresos" className={({ isActive }) => isActive ? 'active' : ''}>Ingresos</NavLink>
                    <NavLink to="/reports" className={({ isActive }) => isActive ? 'active' : ''}>Reportes</NavLink>
                    {user.role === 'admin' && (
                        <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>Admin</NavLink>
                    )}
                </nav>
            )}

            {isLoggedIn && (
                <div className="user-controls">
                    <p className="user-greeting">Hola, {user.username}</p>
                    {user.role === 'admin' && <EmergencyButton />}
                    <NavLink to="/aprobaciones" className={({ isActive }) => `btn btn-outline-secondary btn-sm approvals-bell${isActive ? ' active' : ''}`}
                        title={user.role === 'admin' ? 'Aprobaciones pendientes' : 'Mis solicitudes de aprobación'} aria-label="Aprobaciones">
                        <i className="bi bi-bell" />
                        {bellCount > 0 && <span className={`approvals-badge${bellDenied ? ' denied' : ''}`}>{bellCount > 99 ? '99+' : bellCount}</span>}
                    </NavLink>
                    <NavLink to="/conduces?tab=pedidos" className={({ isActive }) => `btn btn-outline-secondary btn-sm approvals-bell${isActive && location.search.includes('pedidos') ? ' active' : ''}`}
                        title="Pedidos de clientes (CG Connect)" aria-label="Pedidos de clientes">
                        <i className="bi bi-phone" />
                        {pedidos.open > 0 && <span className={`approvals-badge${pedidos.pending > 0 ? '' : ' info'}`}>{pedidos.open > 99 ? '99+' : pedidos.open}</span>}
                    </NavLink>
                    <WhatsAppBadge />
                    <NavLink to="/change-password" className="btn btn-outline-secondary btn-sm" title="Cambiar mi contraseña">
                        <i className="bi bi-key" />
                    </NavLink>
                    <button className="btn btn-danger" onClick={logout} title="Cerrar sesión" aria-label="Cerrar sesión">
                        <span className="logout-text">Cerrar sesión</span>
                        <i className="bi bi-box-arrow-right logout-icon" />
                    </button>
                </div>
            )}
        </header>
    );
};

export default Header;
